import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StandardDialog } from '../../main/dialogs';

import { Button, LoadingIndicator } from '../../components';
import LearningContent from '../../main/course/learning-content';

class CardModal extends Component {

  renderContent() {
    if (!this.props.card) {
      return <div style={{ textAlign: 'center', padding: 50 }}><LoadingIndicator /></div>;
    }

    return <LearningContent content={this.props.card} />;
  }
  render() {
    const actions = [
      <Button
        label="Zurück"
        color="primary"
        style={{ color: 'black' }}
        onClick={this.props.onClose}
      />,
    ];

    return (
      <StandardDialog
        // contentClassName="cardModalContent"
        // paperClassName="cardModalContentInner"
        // modal
        open={this.props.open}
        actions={actions}
        title={this.props.title}
        onRequestClose={this.props.onClose}
      >
        {this.renderContent()}
      </StandardDialog>
    );
  }
}

CardModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  cardId: PropTypes.number.isRequired,

};

export default CardModal;



// WEBPACK FOOTER //
// ./src/app/components/question_answering/card-modal.js